<template>
  <main-content-layout
    :title="$gettext('ECONOMY')"
    buttonIconName="list"
  >
    <div class="tw-p-5">
      <jt-data-table
        v-if="datatable"
        id="jt-composition"
        :api-mode="false"
        :data="tabela.registros"
        :fields="datatable.columns"
        :is-paginated="false"
        :title="titleTeble"
        row-buttons
        noneselect
        @action-button="actionButton"
      />
    </div>
    <modal
      ref="includModal"
      :show="flModal"
      :forms="forms"
      :label="this.$gettext('CONSUMER_UNIT_TYPE_QUANTITY')"
      @action-button="actionButtonModal"
    />
  </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { Dialog } from 'quasar'
import EconomyUnitController from './ServiceRequestEconomyUnitController'
import { JtDataTable, JtCrud } from 'jtech-webcomps'
import MainContentLayout from '../../Layout/MainContentLayout.vue'
const { modal } = JtCrud

@Component({
  name: 'ServiceRequestEconomy',
  components: { JtDataTable, modal, Dialog, MainContentLayout },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestEconomy extends Vue {
  economyUnitController = EconomyUnitController.getInstance();
  datatable = null;
  data = [];
  tabela = [];
  flModal = false;
  pageDialog = null;
  forms = null;

  async actionButton (button, params) {
    if (button.name == 'icAlterar') {
      this.forms = await this.economyUnitController.loadFormAlterar({
        ...params
      })
      this.flModal = true
      this.loadEconomys()
    } else if (button.name == 'icExcluir') {
      this.$q
        .dialog({
          title: Vue.prototype.$gettext('CONFIRMATION'),
          message: Vue.prototype.$gettext('DELETE_CONFIRMATION_MSG'),
          ok: Vue.prototype.$gettext('YES'),
          cancel: Vue.prototype.$gettext('NO'),
          preventClose: true
        })
        .onOk(async () => {
          await this.economyUnitController.deleteCategory(params.id)
          this.loadEconomys()
        })
    }
  }

  async mounted () {
    const datatables = await this.economyUnitController.loadDatatable()
    this.datatable = datatables
    this.loadEconomys()
  }

  async loadEconomys () {
    const registros = await this.economyUnitController.loadDatatableModel({
      consumerUnit: parseInt(this.consumerUnit, 10)
    })
    this.tabela = registros
  }

  async openModal () {
    this.forms = await this.economyUnitController.loadForm()
    this.flModal = true
  }

  async actionButtonModal (params) {
    if (params.name == 'btGravar') {
      await this.economyUnitController.createUnitCategory({
        consumerUnit: this.consumerUnit,
        ...this.forms[0].dadosForm
      })
      this.loadEconomys()
      this.flModal = false
    }
  }
}
export default ServiceRequestEconomy
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

h6 {
  font-size: 20px;
  margin: 3px 20px;
  color: $light-d;
}

.layout {
  height: 700px;
  background-color: $off-white;
}

.q-btn {
  float: right;
}
</style>
